document.addEventListener("DOMContentLoaded", function () {
  const lang = document.documentElement.lang; // e.g. "ar" or "en"
  
  const translations = {
      silver: lang === "ar" ? "فضي" : "Silver",
      gold: lang === "ar" ? "ذهب" : "Gold",
      diamond: lang === "ar" ? "الماس" : "Diamond"
    };


    const storedData = localStorage.getItem("CustomerData");
      if (storedData) {
        const customer = JSON.parse(storedData);
        const tier = customer.tierName.toLocaleString();        
        document.getElementById("usercontact").textContent = customer.phone;
        const tierKey = customer.tierName.toLowerCase();

      const tierTranslated = translations[tierKey] || customer.tierName;
      document.getElementById("userTier").textContent = tierTranslated;
        const tierName = customer.tierName ? customer.tierName.toLowerCase() : "";
        if (tierName) {
          const tierElement = document.querySelector(".tier-" + tierName);
          if (tierElement) {
            tierElement.classList.add("active-tier");
          }
        }
      } else {
        document.getElementById("customerTier").textContent = "";
      }

      const CustomerPoints = localStorage.getItem("CustomerPoints");

      if (CustomerPoints) {
        const data = JSON.parse(CustomerPoints);

        // Show available points
        document.getElementById("userPoints").textContent =
          data.avaliablePoints.toLocaleString();
      }
    });